import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-r6",
  "use": "icon-r6-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-r6\">\r\n  <g transform=\"matrix(1 0 0 1 -92 -1424 )\">\r\n    <path d=\"M 42.0017631578947 10.34837890625  L 21.999951754386 0.0628203125  L 2.12570175438597 10.28203515625  L 22.1275131578947 20.56566015625  L 42.0017631578947 10.34837890625  Z M 1 13.116640625  L 1 33.6895625  L 21 43.9371796875  L 21 23.36997265625  L 1 13.116640625  Z M 43 13.247265625  L 23 23.500640625  L 23 43.9371796875  L 43 33.6895625  L 43 13.247265625  Z \" fill-rule=\"nonzero\" fill=\"#a4a1fc\" stroke=\"none\" transform=\"matrix(1 0 0 1 92 1424 )\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/r6.svg
// module id = l6Co
// module chunks = 0